import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

export function getIntegrationData(id_integration_data) {
    return axios.patch(`${REACT_APP_API}/integrations/getIntegrationData`, {
        id: id_integration_data
    })
}
